import { useState, useEffect, lazy, Suspense, useContext } from "react"
import { useParams } from 'react-router'
import ThemeContext from '../context/ThemeContext';
import api from '../components/api'
import styles from '../assets/css/module/article.module.css'
const Article = lazy(() => import ('../components/Food/FoodClips'))

export default function LannaFoodClip(props) {
    const params = useParams();
    const { language, page, init } = useContext(ThemeContext);

    useEffect(()=>{
        window.addEventListener("scroll", reveal);
        reveal();
    },[]);

    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
    }

    return (
        <div className={styles["article-container"]}>
            <div className={"content reveal"}>
                <Article styles={styles} food_id={params.foodId} />
            </div>
        </div>
    )
}